import ReactDom from "react-dom";
import "./App"
import 'semantic-ui-css/semantic.min.css'
import App from "./App";

ReactDom.render (
<App/>,document.getElementById ("root"));